import { ReactNode } from 'react';
import Term from '../../../components/ui/Term';
import { GLOSSARY, type GlossaryKey } from '../../../lib/glossary';

interface Props {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  /** Value colour: `down` is the artboard's red (below the usual level). */
  tone?: 'default' | 'down';
  help?: GlossaryKey | string;
}

/** Artboard `.ms`: a 12px-radius note tile with a 10px mono label, 18px mono value and a 12px caption. */
export default function MiniStat({ label, value, sub, tone = 'default', help }: Props) {
  return (
    <div className="min-w-0 rounded-[12px] bg-note px-3 py-2.5">
      <span className="block font-mono text-[10px] font-semibold uppercase tracking-[0.08em] text-muted">
        {help ? <Term {...(help in GLOSSARY ? { k: help as GlossaryKey } : { def: help })}>{label}</Term> : label}
      </span>
      <b className={`mt-1 block font-mono text-lg font-semibold ${tone === 'down' ? 'text-danger' : 'text-ink'}`}>{value}</b>
      {sub && <span className="block text-xs text-muted">{sub}</span>}
    </div>
  );
}
